/**
 * The public careers page (`/join-us/{slug}`): its URL shapes and the one test for "this document is inside
 * someone else's page". Every place that has to treat the page differently — the router, the 401 redirect, the
 * session refresh on load, the trackers — asks here, so they can never disagree on which paths are public.
 *
 * The page needs no login: anyone with the link (or a customer's website that frames it) reads it.
 */

/** The public careers area's first path segment. */
export const PUBLIC_CAREERS_ROOT = "/join-us";

/** The job list's pattern in the route table. */
export const PUBLIC_CAREERS_ROUTE = `${PUBLIC_CAREERS_ROOT}/:slug`;

/** One job's page (and its application form) in the route table. */
export const PUBLIC_CAREERS_JOB_ROUTE = `${PUBLIC_CAREERS_ROUTE}/jobs/:jobId`;

/** A department's job list. */
export const publicCareersPath = (slug: string): string => `${PUBLIC_CAREERS_ROOT}/${slug}`;

/** One job's page on a department's careers page. */
export const publicCareersJobPath = (slug: string, jobId: string): string => `${publicCareersPath(slug)}/jobs/${jobId}`;

/** True for `/join-us` and everything under it — never for a path that only starts with the same letters. */
export const isPublicCareersPath = (pathname: string): boolean => pathname === PUBLIC_CAREERS_ROOT || pathname.startsWith(`${PUBLIC_CAREERS_ROOT}/`);

/**
 * True when this document is shown inside another page's iframe (a customer's website embedding the careers page).
 * Comparing the two window references is allowed across origins; reading anything ON the parent is not.
 */
export const isFramedWindow = (): boolean => window.self !== window.top;
